import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { connect } from 'react-redux';
import { useFormik } from 'formik';
// import { Error, Loading } from '../shared';
// import { toast } from "react-toastify";
import * as Yup from "yup";
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';

import { login, 
    verifyRecaptcha 
} from '../../actions/authAction';
import { register } from '../../actions/authAction'
// import ReCAPTCHA from "react-google-recaptcha";
import './style.css';
import logo from '../../assets/icons/MetaBrief_horizontal_RBG.jpg'
import { VALIDATE_EMAIL, VALIDATE_PASSWORD, VALIDATE_CONTACT_NO, VALIDATE_NAME} from '../../constants/constants'

const Register = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [reCaptchavalue, setValue] = useState('')
    const [viewPassword, setViewPassword] = useState('password')
    const [isVerified, setVerifyCaptcha] = useState(true);

    function onChange(value) {
        let response = { value: value }
        return verifyRecaptcha(response)
            .then((result) => setVerifyCaptcha(result?.data?.data?.success))
    }
    const { loading } = useSelector(state => state.register)
    const formik = useFormik({
        initialValues: {
            first_name: '',
            last_name: '',
            email: '',
            type: '',
            contact_no: '',
            password: '',
            passwordConfirmation: '',
            reCaptcha: reCaptchavalue
        },
        validationSchema: Yup.object({
            first_name: Yup.string().required('First name is requied').min(3, 'First name should be greater than 3').max(15, 'First name should be less than 15')
            .matches(VALIDATE_NAME, "Only alphabates are allowed for this field").test('first_name', 'First name is required', (value)=>value?.trim()),
            last_name: Yup.string().required('Last Name is requied').min(3, 'Last name should be greater than 3').max(15, 'Last name should be less than 15')
            .matches(VALIDATE_NAME, "Only alphabates are allowed for this field").test('last_name', 'Last name is required', (value)=>value?.trim()),
            contact_no: Yup.string().required('Mobile Number is requied').matches(VALIDATE_CONTACT_NO, "Enter valid mobile number"),
            email: Yup.string().required('Email is required').matches(VALIDATE_EMAIL, "Email is invalid"),
            password: Yup.string().max(12, 'Must be 12 characters or less').min(6, 'Must be 6 characters or more').required('Please Enter your password').matches(VALIDATE_PASSWORD,"Must contain 6 characters, one uppercase, one lowercase, one number and one special case character"),
            passwordConfirmation: Yup.string()
                .oneOf([Yup.ref('password'), null], 'Passwords must match'),
        }),
        onSubmit: (value, { resetForm }) => {
            const userData = {
                first_name: value?.first_name?.trim(),
                last_name: value?.last_name?.trim(),
                email: value.email,
                type: 'client',
                password: value.password,
                contact_no: value.contact_no,
            };
            isVerified && dispatch(register(userData, history));
            // !isVerified && toast.error("ReCAPTCHA Not verify");

            //resetForm();
        },
    });
    const handleClick = (e) => {
        e.preventDefault();
        const passwordStatus = viewPassword === 'password' ? 'text' : 'password'
        console.log(passwordStatus);
        setViewPassword(passwordStatus);
    }
    return (
        <div id="wrapper" className="au th-main">
            <div className="container">
                <div className="row clearfix">
                    {/* <div className="col-12">
                        <nav className="navbar navbar-expand-lg">
                            <span className="navbar-brand" ><img src={logo} width="130" height="40" className="d-inline-block align-top mr-2" alt="" /></span>
                            <ul className="navbar-nav">
                                <li className="nav-item"><Link className="nav-link" to="/login">LogIn</Link></li>
                            </ul>
                        </nav>
                    </div> */}
                    <div className="col-md-4 mx-auto ">
                        <div className="card custom_card border-radius-10">
                            <div className="header text-center pb-0">
                            <p className="lead"><span className="navbar-brand" ><img src={logo} width="110" height="auto" className="img-fluid mt-2" alt="" /></span></p>

                             <h4 className='login_text'><strong>Register</strong></h4>   
                            </div>
                            {/* {error && <Error error={error} />} */}
                            <div className="body">
                                <form className="form-auth-small" onSubmit={formik.handleSubmit}>
                                    <div className="form-group relative_pos">
                                        <label htmlFor="signup-first_name" className="control-label sr-only">First Name</label>
                                        <span className='text_icon_input'><i className="icon-user"></i></span>
                                        <input type="text" {...formik.getFieldProps('first_name')} className="form-control custom_form_new" placeholder="First Name" required />
                                        {formik.touched.first_name && formik.errors.first_name ? (
                                            <div className="text-danger pt-1">{formik.errors.first_name}</div>
                                        ) : null}
                                    </div>
                                    <div className="form-group relative_pos">
                                        <label className="control-label sr-only" htmlFor="name">Last Name</label>
                                        <span className='text_icon_input'><i className="icon-user"></i></span>
                                        <input type="text" {...formik.getFieldProps('last_name')} className="form-control custom_form_new" placeholder="Last Name" required />
                                        {formik.touched.last_name && formik.errors.last_name ? (
                                            <div className="text-danger pt-1">{formik.errors.last_name}</div>
                                        ) : null}
                                    </div>
                                    {/* <div className="form-group">
                                    <label className="control-label sr-only" htmlFor="name">Username</label>
                                    <input type="text" {...formik.getFieldProps('username')} className="form-control" placeholder="Username" required />
                                    {formik.touched.username && formik.errors.username ? (
                                        <div className="text-danger pt-1">{formik.errors.username}</div>
                                    ) : null}
                                </div> */}
                                    <div className="form-group relative_pos">
                                        <label htmlFor="signup-email" className="control-label sr-only">Email</label>
                                        <span className='text_icon_input'><i className="icon-envelope"></i></span>
                                        <input type="email" {...formik.getFieldProps('email')} className="form-control custom_form_new" placeholder="Email" required />
                                        {formik.touched.email && formik.errors.email ? (
                                            <div className="text-danger pt-1">{formik.errors.email}</div>
                                        ) : null}
                                    </div>
                                    <div className="form-group relative_pos">
                                    <span className='text_icon_input'><i className="fa fa-phone"></i></span>
                                        <label className="control-label sr-only" htmlFor="name">Mobile no</label>
                                        {/* <input type="text" {...formik.getFieldProps('contact_no')} className="form-control" placeholder="Mobile no" required /> */}
                                        <PhoneInput
                                            className="form-control custom_form_new"
                                            defaultCountry="AU"
                                            countries={["AU"]}
                                            placeholder="Enter contact number"
                                            name="contact_no"
                                            {...formik.getFieldProps('contact_no')}
                                            onChange={(value) => { formik.setFieldValue('contact_no', value) }}
                                        />

                                        {formik.touched.contact_no && formik.errors.contact_no ? (
                                            <div className="text-danger pt-1">{formik.errors.contact_no}</div>
                                        ) : null}
                                    </div>
                                    <div className="form-group relative_pos">
                                        <label htmlFor="signup-password" className="control-label sr-only">Password</label>
                                        <div className='pass-wrapper'>
                                        <span className='text_icon_input'><i className="icon-lock"></i></span>
                                            <input name="password" type={viewPassword} {...formik.getFieldProps('password')} className="form-control custom_form_new" placeholder="Password" required />
                                            <span className="password__show" onClick={handleClick}>{viewPassword === 'text' ? <i className='fa fa-eye eyeIcon'></i> : <i className='eyeIcon fa fa-eye-slash'></i>}</span>
                                        </div>
                                        {formik.touched.password && formik.errors.password ? (
                                            <div className="text-danger pt-1">{formik.errors.password}</div>
                                        ) : null}
                                    </div>
                                    <div className="form-group relative_pos">
                                        <label htmlFor="signup-password" className="control-label sr-only">Confirm Password</label>
                                        <span className='text_icon_input'><i className="icon-lock"></i></span>
                                        <input type="password" {...formik.getFieldProps('passwordConfirmation')} className="form-control custom_form_new" placeholder="Confirm Password " required />
                                        {formik.touched.passwordConfirmation && formik.errors.passwordConfirmation ? (
                                            <div className="text-danger pt-1">{formik.errors.passwordConfirmation}</div>
                                        ) : null}
                                    </div>
                                    {/* <ReCAPTCHA
                                        sitekey="6LfutyweAAAAAHEV5lBfIMnN8Lhb4Bw0bG84e6P3"
                                        {...formik.getFieldProps('reCaptcha')}
                                        onChange={onChange}
                                    /> */}
                                    {formik.touched.reCaptcha && formik.errors.reCaptcha ? (
                                        <div className="text-danger">{formik.errors.reCaptcha}</div>
                                    ) : null}
                                    <button type="submit" className="btn button btn-lg btn-block" disabled={loading ? true : false}>REGISTER</button>
                                </form>
                                <div className="bottom mt-4 text-center">
                                        <span>Do you have an account? <Link to="/login">Login</Link></span>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>



    );
};

const mapStateToProps = (state) => ({
    user: state.user,
    loading: state.loading,
    error: state.error,
});

const mapDispatchToProps = {
    login,
};

export default connect(mapStateToProps, mapDispatchToProps)(Register);
